<ng-container *ngIf="(account$ | async) as account">

  <p-card class="card-info w-full my-3">
    <p class="text-center"><strong>Note:</strong> For optimal performance, please add or edit sources within an <em>empty</em> arrangement. Making these changes in an active arrangement may cause issues.</p>
  </p-card>

  <p-table 
    #sourcesTable 
    [value]="account.data.firstCall.sourceGroup" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="sourcesTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="body" let-sourceGroup>
      <tr [pSelectableRow]="sourceGroup">
        <td class="source-text">{{ sourceGroup.name }}</td>
        <td class="source-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditSource($event, sourceGroup)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!sourceGroup.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteSource($event, sourceGroup)" class="p-button-rounded p-button-danger p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>